"use client";

import { motion, useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";

import type { MockupWindowProps } from "./MockupScene.types";

export const MockupWindow = ({
  children,
  title,
  url,
  className,
  floating = false,
}: MockupWindowProps) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className={cn(
        "w-full overflow-hidden rounded-xl border border-zinc-200/50 bg-white shadow-[0_20px_56px_-24px_rgba(0,0,0,0.18)] dark:border-white/[0.05] dark:bg-[#14161A] dark:shadow-[0_20px_56px_-24px_rgba(0,0,0,0.85)]",
        className,
      )}
      animate={
        prefersReducedMotion || !floating ? undefined : { y: [0, -4, 0] }
      }
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
    >
      <div className="flex items-center gap-2 border-b border-zinc-200/50 px-3 py-2 dark:border-white/[0.06]">
        <div className="flex gap-1">
          <span className="size-2 rounded-full bg-[#ff5f57]" />
          <span className="size-2 rounded-full bg-[#febc2e]" />
          <span className="size-2 rounded-full bg-[#28c840]" />
        </div>
        {url ? (
          <div className="mx-auto max-w-[65%] truncate rounded-md bg-zinc-100 px-2.5 py-0.5 text-[9px] text-zinc-500 dark:bg-white/[0.06] dark:text-white/45">
            {url}
          </div>
        ) : null}
        {title && !url ? (
          <p className="text-[10px] font-medium text-zinc-600 dark:text-white/70">
            {title}
          </p>
        ) : null}
      </div>
      {children}
    </motion.div>
  );
};
